
<div :class="jel_getClassObject(content)">
  <EditableArea
    v-if="hasInfo"
    :content="content.confirmationCanafe"
    :parentTemplateId="metadata['mgnl:template']"
  />
  <div
    v-else
    id="spinner"
    class="spinner-fullscreen d-flex flex-column justify-content-center align-items-center text-center"
  >
    <b-spinner :label="$t('chargement')"></b-spinner>
  </div>
</div>
